window.sleep = function(timeMS) {
  return new Promise((resolve, reject) => {
    setTimeout(() => resolve(), timeMS);
  });
};

window.formatToReal = (value) => new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
  minimumFractionDigits: 2,
}).format(value);
